import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { HeaderComponent } from '@components/@shared/header/header.component';

@Component({
  selector: 'ciwc-app-main-layout',
  templateUrl: './main-layout.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent
  ],
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent {
}
